import { render, staticRenderFns } from "./accounting.vue?vue&type=template&id=40c38ce2&"
import script from "./accounting.vue?vue&type=script&lang=ts&"
export * from "./accounting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports